import { useSettings } from './useSettings';
import { useSelectedOrganization } from './useSelectedOrganization';
import { useEffect, useState } from 'react';
import { WorkspaceSettingsForPostEditor } from './usePostEditorNew';

export const usePostEditorWorkspaceSettings = (): WorkspaceSettingsForPostEditor | null => {
  const { selectedWorkspaceSettings } = useSettings();
  const { selectedWorkspace } = useSelectedOrganization();
  const [workspaceSettings, setWorkspaceSettings] = useState<WorkspaceSettingsForPostEditor | null>(
    selectedWorkspaceSettings && selectedWorkspace
      ? {
          evergreen: selectedWorkspaceSettings.evergreenRecycling,
          queuePosition: selectedWorkspaceSettings.defaultQueuePosition,
          varyMedia: selectedWorkspaceSettings.multiMediaAttachMode,
          scheduledTimezone: selectedWorkspace.timezone
        }
      : null
  );

  useEffect(() => {
    if (selectedWorkspace && selectedWorkspaceSettings) {
      setWorkspaceSettings(old => {
        if (old) {
          const newValue = {
            evergreen: selectedWorkspaceSettings.evergreenRecycling,
            queuePosition: selectedWorkspaceSettings.defaultQueuePosition,
            varyMedia: selectedWorkspaceSettings.multiMediaAttachMode,
            scheduledTimezone: selectedWorkspace.timezone
          };
          return JSON.stringify(old) !== JSON.stringify(newValue) ? newValue : old;
        } else {
          return {
            evergreen: selectedWorkspaceSettings.evergreenRecycling,
            queuePosition: selectedWorkspaceSettings.defaultQueuePosition,
            varyMedia: selectedWorkspaceSettings.multiMediaAttachMode,
            scheduledTimezone: selectedWorkspace.timezone
          };
        }
      });
    } else if (!selectedWorkspace && !selectedWorkspaceSettings) {
      setWorkspaceSettings(null);
    }
  }, [selectedWorkspace, selectedWorkspaceSettings]);

  return workspaceSettings;
};
